import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Typography,
  Alert,
  Autocomplete
} from "@mui/material";

import {
  getDataEmployeesByAirportAndCompany,
  getAllEmployeePositions
} from './logic';
import { DataGrid } from '@mui/x-data-grid';
import { Spanish } from '../../../../shared/grid-translations';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Delete from '@mui/icons-material/Delete';
import { ACTIONS } from '../../../../shared/constants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { useSnackbar } from 'notistack';
import { getUser } from '../../../../shared/auth-service';
import dayjs from "dayjs";

const CampaingSource = ({
  handleClose,
  handleSaveSources,
  data,
  allNewsletter = [],
  airports = [],
  employeePositions = [],
  customers = [],
  companies = [],
  newsletterStates = [],
  newsletterTypes,
  assessments,
  campaignContentTypes = [],
  airportId,
  employeeId,
  action,
  onlyEnabledCustomerEmployees = false
}) => {
  const user = getUser();
  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState(data?.name || "");
  const [code, setCode] = useState(data?.code || "");
  const [date, setDate] = useState(data?.startDate || new Date());
  const [endDate, setEndDate] = useState(
    data?.endDate ? data.endDate : dayjs().add(30, "day").toDate()
  );
  const [customerId, setCustomerId] = useState(data?.customerId || null);
  const [companyId, setCompanyId] = useState(data?.companyId || null);
  const [campaignStateId, setCampaignStateId] = useState(data?.campaignStateId || null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(employeeId || null);

  const { id } = data || {};
  const isDataReadOnly = action !== ACTIONS.NEW;

  const [selectedEmployeePositions, setSelectedEmployeePositions] = useState(data?.employeePositions || []);
  const [selectedEmployeePositionId, setSelectedEmployeePosition] = useState(null);
  const [selectedAirports, setSelectedAirports] = useState(data?.airports || []);
  const [selectedPersons, setSelectedPersons] = useState(data?.personCharge || []);
  const [selectedAirportId, setSelectedAirport] = useState(null);
  const [selectedAirportEmployee, setSelectedAirportEmployee] = useState(null);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [value, setValue] = useState('1');
  const [selectedCampaignContentType, setSelectedCampaignContentType] = useState(null);
  const [selectedNewsletter, setSelectedNewsletter] = useState(null);
  const [selectedNameCampaign, setNameCampaign] = useState("");
  const [selectedDescriptionCampaign, setDescriptionCampaign] = useState("");
  const [employeePositionsList, setEmployeePositionsList] = useState(employeePositions || []);
  const [allEmployeePositionsCatalog, setAllEmployeePositionsCatalog] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [userId, setUserId] = useState(data != null ? data.id : 0);
  const [isLoadingPositionsForEdit, setIsLoadingPositionsForEdit] = useState(false);

  const generalCompanyId = user.countryCode.split('-')[0];

  // const allAirportsOption = { id: -1, code: "TODAS", name: "TODAS" };
  const airportsWithOptions = [
    // allAirportsOption,
    ...airports
  ];

  // const allEmployeePositionOption = { id: -1, code: "TODOS", name: "TODOS" };
  const employeePositionWithOptions = [
    ...(companyId
      ? [{
          id: `all-${companyId}`,
          code: "TODOS",
          name: "TODOS",
          companyId,
          isAllPositionsOption: true,
          company:
            companies.find((company) => company.id === companyId)?.shortName || "",
          companyName:
            companies.find((company) => company.id === companyId)?.shortName || ""
        }]
      : []),
    ...employeePositionsList
  ];

  const getCompanyNameFromPerson = (person = {}) => {
    return (
      person.company ||
      person.companyName ||
      person.company?.shortName ||
      person.company?.name ||
      person.shortName ||
      companies.find((company) => company.id === person.companyId)?.shortName ||
      companies.find((company) => company.id === person.company?.id)?.shortName ||
      ""
    );
  };

  const collapseAllPositionsSelections = (positions = []) => {
    if (!positions.length) {
      return [];
    }

    const positionsByCompany = positions.reduce((accumulator, position) => {
      const companyKey = position.companyId || "without-company";
      if (!accumulator[companyKey]) {
        accumulator[companyKey] = [];
      }

      accumulator[companyKey].push(position);
      return accumulator;
    }, {});

    return Object.values(positionsByCompany).flatMap((companyPositions) => {
      const companyIdFromGroup = companyPositions[0]?.companyId || null;
      if (!companyIdFromGroup) {
        return companyPositions;
      }

      const catalogPositions = allEmployeePositionsCatalog.filter(
        (catalogPosition) => catalogPosition.companyId === companyIdFromGroup
      );

      const uniqueSelectedIds = [...new Set(companyPositions.map((position) => position.id))];
      const uniqueCatalogIds = [...new Set(catalogPositions.map((position) => position.id))];
      const hasAllPositionsSelected =
        uniqueCatalogIds.length > 0 &&
        uniqueSelectedIds.length === uniqueCatalogIds.length &&
        uniqueCatalogIds.every((id) => uniqueSelectedIds.includes(id));

      if (!hasAllPositionsSelected) {
        return companyPositions;
      }

      const companyName =
        companyPositions[0]?.companyName ||
        companyPositions[0]?.company ||
        companies.find((company) => company.id === companyIdFromGroup)?.shortName ||
        "";

      return [{
        id: `all-${companyIdFromGroup}`,
        code: "TODOS",
        name: "TODOS",
        companyId: companyIdFromGroup,
        company: companyName,
        companyName,
        isAllPositionsOption: true
      }];
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getNewsletterIdFromItem = (item = {}) => {
    return (
      item.newsletterId ??
      item.circularId ??
      item.newsLetterId ??
      item.newsletter?.id ??
      item.circular?.id ??
      item.newsLetter?.id ??
      item.content?.id ??
      item.id ??
      0
    );
  };

  const getNewsletterNameFromItem = (item = {}, fullNewsletter = null) => {
    return (
      item.title ??
      item.name ??
      item.newsletterName ??
      item.circularName ??
      item.newsletter?.title ??
      item.newsletter?.name ??
      item.circular?.title ??
      item.circular?.name ??
      item.newsLetter?.title ??
      item.newsLetter?.name ??
      item.content?.title ??
      item.content?.name ??
      fullNewsletter?.title ??
      fullNewsletter?.name ??
      ""
    );
  };

  const getNewsletterDescriptionFromItem = (item = {}, fullNewsletter = null) => {
    return (
      item.content ??
      item.description ??
      item.detail ??
      item.newsletter?.content ??
      item.newsletter?.description ??
      item.circular?.content ??
      item.circular?.description ??
      item.newsLetter?.content ??
      item.newsLetter?.description ??
      item.content?.content ??
      item.content?.description ??
      fullNewsletter?.content ??
      fullNewsletter?.description ??
      ""
    );
  };

  const normalizeArray = (value) => {
    if (Array.isArray(value)) {
      return value;
    }

    if (value && typeof value === "object") {
      return [value];
    }

    return [];
  };

  const isCircularContent = (item = {}) => {
    const contentTypeId =
      item.campaignContentTypeId ??
      item.contentTypeId ??
      item.typeId ??
      item.type?.id ??
      item.contentType?.id;

    const contentTypeName = (
      item.campaignContentTypeName ??
      item.contentTypeName ??
      item.type ??
      item.type?.name ??
      item.contentType?.name ??
      ""
    ).toString().toLowerCase();

    return (
      contentTypeId === 2 ||
      contentTypeName.includes("circular") ||
      contentTypeName.includes("newsletter") ||
      item.newsletterId != null ||
      item.circularId != null ||
      item.newsLetterId != null ||
      item.newsletter != null ||
      item.circular != null ||
      item.newsLetter != null
    );
  };

  const isActivityContent = (item = {}) => {
    const contentTypeId =
      item.campaignContentTypeId ??
      item.contentTypeId ??
      item.typeId ??
      item.type?.id ??
      item.contentType?.id;

    const contentTypeName = (
      item.campaignContentTypeName ??
      item.contentTypeName ??
      item.type ??
      item.type?.name ??
      item.contentType?.name ??
      ""
    ).toString().toLowerCase();

    return (
      contentTypeId === 1 ||
      contentTypeName.includes("actividad") ||
      (item.newsletterId == null &&
        item.circularId == null &&
        item.newsLetterId == null &&
        item.newsletter == null &&
        item.circular == null &&
        item.newsLetter == null)
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedAirportEmployee || !companyId) {
        setEmployees([]);
        return;
      }

      setLoadingEmployees(true);
      const employeesData = await getDataEmployeesByAirportAndCompany(
        selectedAirportEmployee,
        companyId
      );
      setEmployees(employeesData);
      setLoadingEmployees(false);

      if (isDataReadOnly) {
        const employeeToSelect = employeesData.find(
          e => e.employeeId === selectedEmployeeId
        );
        setEmployeeSelected(employeeToSelect || null);
      }
    };

    fetchData();
  }, [action, employeeId, selectedAirportEmployee, companyId, isDataReadOnly, selectedEmployeeId]);

  useEffect(() => {
    const fetchEmployeePositions = async () => {
      if (!companyId) {
        setEmployeePositionsList([]);
        return;
      }

      const positions = await getAllEmployeePositions(companyId);
      setEmployeePositionsList(positions || []);
    };

    fetchEmployeePositions();
  }, [companyId]);

  useEffect(() => {
    const fetchAllEmployeePositionsCatalog = async () => {
      if (!companies.length) {
        setAllEmployeePositionsCatalog([]);
        return;
      }

      const positionsByCompany = await Promise.all(
        companies.map(async (company) => {
          const positions = await getAllEmployeePositions(company.id);
          return (positions || []).map((position) => ({
            ...position,
            companyId: company.id,
            company: position.company || company.shortName || "",
            companyName: position.company || company.shortName || ""
          }));
        })
      );

      setAllEmployeePositionsCatalog(positionsByCompany.flat());
    };

    fetchAllEmployeePositionsCatalog();
  }, [companies]);

  useEffect(() => {
    if (!data) return;
    if (isDataReadOnly && companies.length > 0 && allEmployeePositionsCatalog.length === 0) {
      setIsLoadingPositionsForEdit(true);
      return;
    }

    const selectedCompany =
      companies.find((company) => company.id === (data.companyId || null)) ||
      null;

    const normalizedEmployeePositions = (data.employeePositions || []).map((position) => {
      if (position.id === -1) {
        const companyName =
          companies.find((c) => String(c.id) === String(data.companyId))?.shortName || "";
        return {
          ...position,
          id: `all-${data.companyId || "legacy"}`,
          name: "TODOS",
          isAllPositionsOption: true,
          companyId: data.companyId || null,
          company: companyName,
          companyName
        };
      }

      const matchingPosition =
        allEmployeePositionsCatalog.find((cp) => String(cp.id) === String(position.id)) ||
        allEmployeePositionsCatalog.find((cp) => position.name && cp.name === position.name);

      return {
        ...position,
        name: position.name || matchingPosition?.name || "",
        companyId: position.companyId || matchingPosition?.companyId || null,
        company: position.company || matchingPosition?.company || "",
        companyName:
          position.company ||
          position.companyName ||
          position.company?.shortName ||
          position.company?.name ||
          matchingPosition?.company ||
          matchingPosition?.companyName ||
          ""
      };
    });

    const employeePositionsToDisplay =
      allEmployeePositionsCatalog.length > 0
        ? collapseAllPositionsSelections(normalizedEmployeePositions)
        : normalizedEmployeePositions;

    setName(data.name || "");
    setCode(data.code || "");
    setDate(data.startDate || new Date());
    setEndDate(data.endDate ? data.endDate : dayjs().add(30, "day").toDate());
    setCustomerId(data.customerId || null);
    setCompanyId(data.companyId || null);
    setCampaignStateId(data.campaignStateId || null);
    setSelectedEmployeePositions(employeePositionsToDisplay);
    setIsLoadingPositionsForEdit(false);
    setSelectedAirports(data.airports || []);
    setSelectedPersons(
      (data.personCharge || []).map((person) => ({
        ...person,
        companyName: getCompanyNameFromPerson(person)
      }))
    );
    setUserId(data.id || 0);

    const rawCirculars = [
      ...normalizeArray(data.newsletterContent),
      ...normalizeArray(data.contentNewsletter),
      ...normalizeArray(data.circulars),
      ...normalizeArray(data.newsletters),
      ...normalizeArray(data.newsletter),
      ...normalizeArray(data.newsLetter),
      ...normalizeArray(data.circular),
      ...normalizeArray(data.campaignNewsletters),
      ...normalizeArray(data.contents).filter(isCircularContent),
      ...normalizeArray(data.content).filter(isCircularContent),
      ...normalizeArray(data.campaignContents).filter(isCircularContent)
    ];

    const circularRows = rawCirculars.map((item, index) => {
      const possibleNewsletterId = getNewsletterIdFromItem(item);

      const fullNewsletter = allNewsletter.find((n) =>
        n.id === possibleNewsletterId ||
        n.id === item.newsletterId ||
        n.id === item.circularId ||
        n.id === item.newsLetterId ||
        n.id === item.newsletter?.id ||
        n.id === item.circular?.id ||
        n.id === item.newsLetter?.id
      );

      return {
        id: `Circular-${possibleNewsletterId || index}`,
        originalId: possibleNewsletterId || 0,
        name: getNewsletterNameFromItem(item, fullNewsletter),
        description: getNewsletterDescriptionFromItem(item, fullNewsletter) || "-",
        type: "Circular"
      };
    });

    const rawActivities = [
      ...normalizeArray(data.activity),
      ...normalizeArray(data.activities),
      ...normalizeArray(data.contentActivity),
      ...normalizeArray(data.campaignActivities),
      ...normalizeArray(data.contents).filter(isActivityContent),
      ...normalizeArray(data.content).filter(isActivityContent),
      ...normalizeArray(data.campaignContents).filter(isActivityContent)
    ];

    const activityRows = rawActivities.map((item, index) => ({
      id: `Actividad-${item.id ?? index}`,
      originalId: item.id || 0,
      name: item.name ?? "",
      description: item.description ?? "",
      type: "Actividad"
    }));

    setRows([...circularRows, ...activityRows]);
  }, [data, allNewsletter, allEmployeePositionsCatalog, companies]);

  const handleDeleteContent = (rowId) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== rowId));
  };

  const handleAddCircular = () => {
    if (!selectedNewsletter) return;

    const exists = rows.some(
      (row) =>
        row.type === "Circular" &&
        (row.id === `Circular-${selectedNewsletter.id}` || row.originalId === selectedNewsletter.id)
    );

    if (exists) {
      enqueueSnackbar("La circular ya fue agregada.", { variant: "info" });
      return;
    }

    setRows((prevRows) => [
      ...prevRows,
      {
        id: `Circular-${selectedNewsletter.id}`,
        originalId: selectedNewsletter.id || 0,
        name: selectedNewsletter.name || "",
        description: selectedNewsletter.content || selectedNewsletter.description || "-",
        type: "Circular",
      },
    ]);

    setSelectedNewsletter(null);
  };

  const handleAddActivity = () => {
    if (selectedNameCampaign.trim() === "") return;

    setRows((prevRows) => [
      ...prevRows,
      {
        id: `Actividad-${Date.now()}`,
        originalId: 0,
        name: selectedNameCampaign.trim(),
        description: selectedDescriptionCampaign.trim(),
        type: "Actividad",
      },
    ]);

    setNameCampaign("");
    setDescriptionCampaign("");
  };

  const handleActionButton = (e, cellValues, source) => {
    e.stopPropagation();

    if (source === 'airport') {
      setSelectedAirports(selectedAirports.filter((el) => el.id !== cellValues.row.id));
    }

    if (source === 'employeePositions') {
      setSelectedEmployeePositions(selectedEmployeePositions.filter((el) => el.id !== cellValues.row.id));
    }

    if (source === 'person') {
      setSelectedPersons(selectedPersons.filter((el) => el.employeeId !== cellValues.row.employeeId));
    }
  };

  const handleAddEmployeePositions = (e) => {
    e.stopPropagation();

    const position = employeePositionWithOptions.find(z => z.id === selectedEmployeePositionId);
    if (!position) return;

    const selectedCompany =
      companies.find((company) => company.id === companyId) || null;

    if (position.isAllPositionsOption) {
      const filteredPositions = selectedEmployeePositions.filter(
        (item) => item.companyId !== selectedCompany?.id
      );

      setSelectedEmployeePositions([
        ...filteredPositions,
        {
          ...position,
          name: "TODOS",
          companyId: selectedCompany?.id || null,
          company: selectedCompany?.shortName || "",
          companyName: selectedCompany?.shortName || ""
        }
      ]);
      return;
    }

    const hasAllCompanyPositionsSelected = selectedEmployeePositions.some(
      (item) => item.companyId === selectedCompany?.id && item.isAllPositionsOption
    );

    if (hasAllCompanyPositionsSelected) {
      enqueueSnackbar(
        `La compañía ${selectedCompany?.shortName || ""} ya tiene seleccionado el cargo Todos.`,
        { variant: "info" }
      );
      return;
    }

    if (
      selectedEmployeePositions.some(
        (item) =>
          item.id === selectedEmployeePositionId &&
          item.companyId === selectedCompany?.id
      )
    ) {
      return;
    }

    setSelectedEmployeePositions([
      ...selectedEmployeePositions,
      {
        ...position,
        companyId: selectedCompany?.id || null,
        company: position.company || selectedCompany?.shortName || "",
        companyName: position.company || selectedCompany?.shortName || ""
      }
    ]);
  };

  const handleAddAirports = (e) => {
    e.stopPropagation();

    if (selectedAirports.some(el => el.id === selectedAirportId)) {
      return;
    }

    const airport = airportsWithOptions.find(z => z.id === selectedAirportId);
    if (!airport) return;

    setSelectedAirports([...selectedAirports, airport]);
  };

  const handleAddPersons = (e) => {
    e.stopPropagation();

    if (!employeeSelected) {
      enqueueSnackbar("Por favor, seleccione una persona antes de agregar.", { variant: "warning" });
      return;
    }

    if (selectedPersons.some(el => el.employeeId === employeeSelected.employeeId)) {
      enqueueSnackbar("La persona ya ha sido agregada.", { variant: "info" });
      return;
    }

    setSelectedPersons([
      ...selectedPersons,
      {
        id: employeeSelected.employeeId,
        employeeId: employeeSelected.employeeId,
        name: `${employeeSelected.name} ${employeeSelected.lastName}`,
        companyId: employeeSelected.companyId || employeeSelected.company?.id || null,
        company: employeeSelected.company || "",
        companyName: getCompanyNameFromPerson(employeeSelected)
      }
    ]);

    setEmployeeSelected(null);
  };

  const validateForm = () => {
    let errors = {};

    if (!name || !name.trim()) errors.name = "El nombre es requerido";
    if (!date) errors.date = "La fecha inicial es requerida";
    if (!endDate) errors.endDate = "La fecha final es requerida";

    const start = dayjs(date).startOf('day');
    const end = dayjs(endDate).startOf('day');

    if (start.isAfter(end)) errors.endDate = "La fecha inicial no puede ser mayor a la fecha final";
    if (!customerId) errors.customerId = "El cliente es requerido";
    if (!campaignStateId) errors.campaignStateId = "El estado de la campaña es requerido";
    if (!selectedAirports.length) errors.selectedAirports = "Agregue al menos un aeropuerto";
    if (!rows.length) errors.rows = "Agregue al menos un contenido a la campaña";
    if (!selectedEmployeePositions.length) errors.selectedEmployeePositions = "Agregue al menos un cargo";

    const activities = rows.filter((row) => row.type === "Actividad");
    if (activities.length > 0 && selectedPersons.length === 0) {
      errors.selectedPersons = "Si hay actividades, debe haber al menos una persona encargada.";
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleSave = () => {
    const errors = validateForm();

    if (errors) {
      const errorMessages = Object.values(errors);
      enqueueSnackbar(
        errorMessages.length > 1
          ? "Por favor, revise todos los campos requeridos."
          : errorMessages[0],
        { variant: "error" }
      );
      return;
    }

    setIsSaveButtonDisabled(true);

    const contentNewsletter = rows
      .filter(row => row.type === 'Circular')
      .map(row => ({
        id: row.id,
        title: row.name,
        name: row.name,
        content: row.description || "-",
        description: row.description || "-"
      }));

    const contentActivity = rows
      .filter(row => row.type === 'Actividad')
      .map(row => ({
        id: row.originalId || 0,
        name: row.name,
        description: row.description || ""
      }));

    const today = dayjs().startOf('day');
    const selectedDate = dayjs(date).startOf('day');
    const finalStateId = selectedDate.isAfter(today) ? 2 : campaignStateId;

    const expandedEmployeePositions = selectedEmployeePositions.flatMap((position) => {
      if (!position.isAllPositionsOption) {
        return [position];
      }

      return allEmployeePositionsCatalog
        .filter((catalogPosition) => catalogPosition.companyId === position.companyId)
        .map((catalogPosition) => ({
          ...catalogPosition,
          companyId: position.companyId,
          company: position.company || catalogPosition.company || "",
          companyName: position.companyName || catalogPosition.companyName || ""
        }));
    });

    const uniqueEmployeePositions = expandedEmployeePositions.filter(
      (position, index, array) =>
        index ===
        array.findIndex(
          (item) =>
            item.id === position.id &&
            (item.companyId || null) === (position.companyId || null)
        )
    );

    handleSaveSources(
      id,
      date,
      endDate,
      finalStateId,
      name,
      customerId,
      uniqueEmployeePositions,
      selectedAirports,
      contentNewsletter,
      contentActivity,
      selectedPersons,
      generalCompanyId
    );
  };

  async function loadEmployeesByAirport(AirportId) {
    setLoadingEmployees(true);
    const employeesData = await getDataEmployeesByAirportAndCompany(AirportId, companyId);
    setEmployees(employeesData);
    setLoadingEmployees(false);
  }

  const airportColumns = [
    {
      field: 'code',
      headerName: 'Base',
      minWidth: 70,
      flex: 1,
      renderCell: (cellValues) => cellValues.id === -1 ? "TODAS" : cellValues.code
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => (
        <IconButton color="error" onClick={(e) => handleActionButton(e, cellValues, 'airport')}>
          <Delete />
        </IconButton>
      )
    }
  ];

  const personColumns = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      minWidth: 350,
      flex: 1
    },
    {
      field: 'employeeId',
      headerName: 'Cedula',
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
      flex: 0.3
    },
    {
      field: 'name',
      headerName: 'Nombre Completo',
      headerAlign: 'center',
      align: 'center',
      minWidth: 350,
      flex: 1
    },
    {
      field: 'companyName',
      headerName: 'Compañia',
      headerAlign: 'center',
      align: 'center',
      minWidth: 140,
      flex: 0.45,
      valueGetter: (params) => getCompanyNameFromPerson(params.row)
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => (
        <IconButton color="error" onClick={(e) => handleActionButton(e, cellValues, 'person')}>
          <Delete />
        </IconButton>
      )
    }
  ];

  const employeePositionsColumns = [
    {
      field: 'companyName',
      headerName: 'Compañía',
      minWidth: 110,
      flex: 0.35,
      valueGetter: (params) =>
        params.row.company ||
        params.row.companyName ||
        params.row.company?.shortName ||
        params.row.company?.name ||
        companies.find((c) => String(c.id) === String(params.row.companyId))?.shortName ||
        ""
    },
    {
      field: 'name',
      headerName: 'Cargo',
      minWidth: 350,
      flex: 1,
      renderCell: (params) => {
        if (params.row.isAllPositionsOption) return "TODOS";
        if (params.value) return params.value;
        const match = allEmployeePositionsCatalog.find(
          (cp) => String(cp.id) === String(params.row.id)
        );
        return match?.name || "";
      }
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => (
        <IconButton color="error" onClick={(e) => handleActionButton(e, cellValues, 'employeePositions')}>
          <Delete />
        </IconButton>
      )
    }
  ];

  const contentColumns = [
    {
      field: 'id',
      headerName: 'Id',
      flex: 0.3,
      headerAlign: 'center',
      hide: true
    },
    {
      field: 'type',
      headerName: 'Tipo',
      flex: 0.3,
      headerAlign: 'center',
    },
    {
      field: 'name',
      headerName: 'Nombre',
      minWidth: 350,
      flex: 1,
      headerAlign: 'center',
    },
    {
      field: 'description',
      headerName: 'Descripción',
      minWidth: 350,
      flex: 1,
      headerAlign: 'center',
      renderCell: (cellValues) => (
        <Typography variant="body2">
          {cellValues.value ?? "-"}
        </Typography>
      )
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      headerAlign: 'center',
      width: 100,
      sortable: false,
      renderCell: (cellValues) => (
        <IconButton color="error" onClick={() => handleDeleteContent(cellValues.row.id)}>
          <Delete />
        </IconButton>
      )
    }
  ];

  return (
    <div>
      <Dialog
        maxWidth="xl"
        fullWidth
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Detalle Campaña ${code || ''} - ${name || ''}`}
        </DialogTitle>

        <DialogContent>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange}>
                  <Tab label="Datos de la campaña" value="1" />
                  <Tab label="Contenido de la campaña" value="2" />
                </TabList>
              </Box>

              <TabPanel value="1">
                <>
                  <span><i>Los campos marcados con * son obligatorios</i></span>

                  <Grid container direction="row" alignItems="center" spacing={2} sx={{ marginTop: '1px' }}>
                    <Grid item xs={1.4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es-ES'}>
                        <FormControl fullWidth margin="dense">
                          <DesktopDatePicker
                            label="Fecha Inicio *"
                            inputFormat="DD/MM/YYYY"
                            value={date}
                            onChange={(e) => setDate(e)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={1.4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es-ES'}>
                        <FormControl fullWidth margin="dense">
                          <DesktopDatePicker
                            label="Fecha Fin *"
                            inputFormat="DD/MM/YYYY"
                            value={endDate}
                            onChange={(e) => setEndDate(e)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={1.4}>
                      <FormControl fullWidth margin="dense">
                        <InputLabel id="state-select-label">Estado *</InputLabel>
                        <Select
                          labelId="state-select-label"
                          label="Estado *"
                          required
                          value={campaignStateId || ""}
                          onChange={(e) => setCampaignStateId(e.target.value)}
                        >
                          {newsletterStates.map((item) => (
                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={3.4}>
                      <FormControl fullWidth margin="dense">
                        <TextField
                          label="Nombre"
                          placeholder="Nombre"
                          value={name || ''}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.2}>
                      <FormControl fullWidth margin="dense">
                        <Autocomplete
                          options={customers}
                          getOptionLabel={(option) => option.name}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          value={customers.find((c) => c.id === customerId) || null}
                          onChange={(event, newValue) => {
                            setCustomerId(newValue?.id || null);
                          }}
                          renderInput={(params) => <TextField {...params} label="Emisor/Cliente" required />}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.2}>
                      <FormControl fullWidth margin="dense">
                        <Autocomplete
                          options={companies}
                          getOptionLabel={(option) => option.shortName}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          value={companies.find((c) => c.id === companyId) || null}
                          onChange={(event, newValue) => {
                            const newCompanyId = newValue?.id || null;
                            setCompanyId(newCompanyId);
                            setSelectedAirportEmployee(null);
                            setEmployees([]);
                            setEmployeeSelected(null);
                            setSelectedAirport(null);
                            setSelectedEmployeePosition(null);
                            //setSelectedAirports([]);
                            //setSelectedEmployeePositions([]);
                          }}
                          renderInput={(params) => <TextField {...params} label="Compañia" required />}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <p />
                  <p />

                  <Typography variant="h6" gutterBottom>
                    Persona(s) Encargada(s) *
                  </Typography>

                  <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={3}>
                      <FormControl fullWidth margin="dense">
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={11}>
                                <Autocomplete
                                  noOptionsText="Sin resultados"
                                  loading={loadingEmployees}
                                  loadingText="Cargando empleados..."
                                  disablePortal
                                  size='small'
                                  options={employees}
                                  getOptionLabel={(option) =>
                                    option ? `${option.employeeId} - ${option.name} ${option.lastName}` : ''
                                  }
                                  value={employeeSelected}
                                  onChange={(event, newValue) => {
                                    setEmployeeSelected(newValue);
                                  }}
                                  disabled={!companyId || !selectedAirportEmployee}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Empleado" />
                                  )}
                                />
                              </Grid>

                              <Grid item xs={1}>
                                <IconButton
                                  disabled={!employeeSelected}
                                  color="primary"
                                  onClick={(e) => { handleAddPersons(e) }}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={11}>
                            <FormControl fullWidth margin="dense">
                              <Autocomplete
                                options={airports}
                                getOptionLabel={(option) => option.code || ""}
                                value={airports.find((a) => a.id === selectedAirportEmployee) || null}
                                onChange={async (event, newValue) => {
                                  const airportSelectedId = newValue ? newValue.id : null;
                                  setSelectedAirportEmployee(airportSelectedId);

                                  if (airportSelectedId && companyId) {
                                    await loadEmployeesByAirport(airportSelectedId);
                                  } else {
                                    setEmployees([]);
                                  }

                                  if (userId === 0) {
                                    setEmployeeSelected(null);
                                  }
                                }}
                                disabled={!companyId}
                                renderInput={(params) => (
                                  <TextField {...params} label="Base" size="small" />
                                )}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </Grid>

                    <Grid item xs={9}>
                      <DataGrid
                        style={{ height: 180 }}
                        columns={personColumns}
                        rows={selectedPersons}
                        localeText={{ ...Spanish }}
                        getRowId={(row) => row.employeeId}
                        hideFooter
                        sx={{
                          '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                          }
                        }}
                      />
                    </Grid>
                  </Grid>

                  <p />
                  <p />

                  <Typography variant="h6" gutterBottom>
                    Target / Público objetivo *
                  </Typography>

                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <FormControl fullWidth margin="dense">
                        <Grid container spacing={1}>
                          <Grid item xs={11}>
                            <Autocomplete
                              options={airportsWithOptions}
                              getOptionLabel={(option) => option.code || ""}
                              value={airportsWithOptions.find((a) => a.id === selectedAirportId) || null}
                              disabled={!companyId}
                              onChange={(event, newValue) => {
                                setSelectedAirport(newValue ? newValue.id : null);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Base" size="small" />
                              )}
                            />
                          </Grid>

                          <Grid item xs={1}>
                            <IconButton
                              disabled={!companyId || !selectedAirportId}
                              color="primary"
                              onClick={(e) => { handleAddAirports(e) }}
                            >
                              <AddCircleIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl fullWidth margin="dense">
                        <Grid container spacing={1}>
                          <Grid item xs={11}>
                            <Autocomplete
                              disablePortal
                              options={employeePositionWithOptions}
                              getOptionLabel={(option) => {
                                if (option.isAllPositionsOption) {
                                  return 'TODOS';
                                }

                                return option.name || "";
                              }}
                              value={employeePositionWithOptions.find((p) => p.id === selectedEmployeePositionId) || null}
                              disabled={!companyId}
                              onChange={(event, newValue) => {
                                setSelectedEmployeePosition(newValue ? newValue.id : null);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Cargo" size="small" />
                              )}
                            />
                          </Grid>

                          <Grid item xs={1}>
                            <IconButton
                              color="primary"
                              disabled={!companyId || !selectedEmployeePositionId}
                              onClick={(e) => { handleAddEmployeePositions(e) }}
                            >
                              <AddCircleIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <p />

                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <DataGrid
                        style={{ height: 350 }}
                        columns={airportColumns}
                        rows={selectedAirports}
                        localeText={{ ...Spanish }}
                        sx={{
                          '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={9}>
                      {isLoadingPositionsForEdit ? (
                        <Box
                          sx={{
                            height: 350,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid rgba(224, 224, 224, 1)',
                            borderRadius: 1
                          }}
                        >
                          <Typography variant="body2">
                            Cargando cargos...
                          </Typography>
                        </Box>
                      ) : (
                        <DataGrid
                          style={{ height: 350 }}
                          columns={employeePositionsColumns}
                          rows={selectedEmployeePositions}
                          localeText={{ ...Spanish }}
                          sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                              fontWeight: 'bold',
                            }
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                </>
              </TabPanel>

              <TabPanel value="2">
                <Grid container spacing={2}>
                  <Grid item xs={9}>
                    <FormControl fullWidth margin="dense">
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <Autocomplete
                            options={campaignContentTypes}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newValue) => setSelectedCampaignContentType(newValue?.id || null)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Tipo contenido"
                                placeholder="Seleccione un tipo de contenido"
                              />
                            )}
                          />
                        </Grid>

                        {selectedCampaignContentType === 1 && (
                          <Grid item xs={8}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={5}>
                                <TextField
                                  fullWidth
                                  label="Nombre"
                                  placeholder="Ingrese el nombre de la actividad"
                                  required
                                  value={selectedNameCampaign}
                                  onChange={(e) => setNameCampaign(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  label="Descripción"
                                  placeholder="Ingrese una descripción de la actividad"
                                  value={selectedDescriptionCampaign}
                                  onChange={(e) => setDescriptionCampaign(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  onClick={handleAddActivity}
                                  disabled={!selectedNameCampaign.trim()}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {selectedCampaignContentType === 2 && (
                          <Grid item xs={7} sx={{ marginLeft: 10 }}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={11}>
                                <Autocomplete
                                  options={allNewsletter}
                                  getOptionLabel={(option) => option.name}
                                  value={selectedNewsletter}
                                  onChange={(event, newValue) => setSelectedNewsletter(newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Circular"
                                      placeholder="Seleccione una circular"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  onClick={handleAddCircular}
                                  disabled={!selectedNewsletter}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ marginTop: 4 }}>
                    <Grid container justifyContent="center" alignItems="center">
                      <Grid item xs={10}>
                        <Box
                          sx={{
                            height: 330,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid #e0e0e0',
                            borderRadius: '4px',
                            padding: 2,
                          }}
                        >
                          <DataGrid
                            columns={contentColumns}
                            rows={rows}
                            localeText={{ ...Spanish }}
                            sx={{
                              width: '100%',
                              '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                              },
                              '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              },
                              '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>

        <DialogActions sx={{ m: 3 }}>
          <Grid container spacing={0}>
            <Grid item xs={8.6}>
              <Alert severity="warning">
                ¡Recuerde que los cambios solo se aplicarán si presiona el botón guardar!
              </Alert>
            </Grid>
            <Grid item xs={0.2}></Grid>
            <Grid item xs={1}>
              <Button
                color="primary"
                variant="contained"
                onClick={handleSave}
                endIcon={<SaveIcon />}
                disabled={isSaveButtonDisabled}
              >
                {isSaveButtonDisabled ? "Guardando..." : ACTIONS.SAVE}
              </Button>
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={1}>
              <Button
                endIcon={<CancelIcon />}
                variant="outlined"
                onClick={() => { handleClose(false) }}
                autoFocus
              >
                {ACTIONS.CANCEL}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CampaingSource;
